import { Component, Input, OnInit, } from '@angular/core';

// Moment
import * as moment from 'moment';

// Components / Modals
import { ContractTermsFreeTrialModalComponent } from '../contract-terms-free-trial-modal/contract-terms-free-trial-modal.component';

// Services
import { BsModalService } from 'ngx-bootstrap';
import { DataService } from '../../services/data.service';

// Model
import { PaymentInfo } from '../../model/free-trial';


@Component({
	selector: 'app-register-payment',
	templateUrl: './register-payment.component.html',
})
export class RegisterPaymentComponent implements OnInit {

	CARD_NUMBER_MIN_LENGTH = 15;

	doneClicked: boolean = false;

	paymentInfo: PaymentInfo = null;

	expiration: string = "";
	agree: boolean = false;

	// Nums for expiration date validation
	private monthNums: string[] = ["01","02","03","04","05","06","07","08","09","10","11","12"];
	private yearNums: number[] = [];

	@Input() autofillFName: string;
	@Input() autofillLName: string;

	// Shows 'agree to terms' area in html
	// @Input() isReview: boolean;
	@Input() existingPaymentInfo: PaymentInfo
	constructor(
		private modalSvc: BsModalService,
		private dataSvc: DataService
	) { 
		this.paymentInfo = new PaymentInfo('','','','','',null,'');

		// Get Year Nums
		let today = moment();
		for (let i in [0,1,2,3,4,5,6,7,8,9,10,11,12,13]) {
			this.yearNums.push(today.clone().year() + Number(i))
		}
	}

	// Set fName and lName if they exist
	ngOnInit() {
		if (!!this.existingPaymentInfo) {
			this.paymentInfo = this.existingPaymentInfo;
			this.expiration = PaymentInfo.getExpirationStrFromDate(this.existingPaymentInfo.expDate);

			// if (!!this.isReview) 
			// 	this.agree = true;
		}
		if (this.autofillFName)
			this.paymentInfo.fName = this.autofillFName;
		if (this.autofillLName)
			this.paymentInfo.lName = this.autofillLName;
	}

	public async btnDone(alias: string): Promise<PaymentInfo> {
		this.doneClicked = true;

		// Check that all fields are valid
		if (!this.canSavePaymentMethod())
			return;

		try {
			// Trim data
			let trimmedFName = this.paymentInfo.fName.trim();
			let trimmedLName = this.paymentInfo.lName.trim();
			let trimmedZip = this.paymentInfo.zip.trim();
			this.paymentInfo.fName = trimmedFName;
			this.paymentInfo.lName = trimmedLName;
			this.paymentInfo.zip = trimmedZip;

			// Prepare credit card data
			let expInfo = this.getExpirationInfo();
            let expDate = PaymentInfo.getExpirationFromMoAndYr(expInfo.expMonth, expInfo.expYear);
			let name = this.paymentInfo.fName + " " + this.paymentInfo.lName
			let response: {token: string} = null;

			// Authorize credit card
			response = await this.dataSvc.authorizeCreditCard(this.paymentInfo.cardNumber, this.paymentInfo.cvv, expDate, name, this.paymentInfo.zip, alias);

			this.paymentInfo.token = response.token;
			this.paymentInfo.expDate = expDate;

			return this.paymentInfo;

		}
		catch(e) {
			return Promise.reject(e);
		}
	}

	// Take Expiration Input and parse out the month and the year
	private getExpirationInfo(): {expMonth, expYear} {
		try {
			let expirationDate = (<HTMLInputElement>document.getElementById("cc-exp-date")).value;

			if (!expirationDate) { return undefined };

			let dateMonthYear: any[] = expirationDate.split("/");
			let expMonth = dateMonthYear[0].trim();
			let expYear = dateMonthYear[1].trim();

			expYear = Number(expYear.length == 4 ? expYear : "20" + expYear);

			return {expMonth, expYear};
		}
		catch(e) {
			return undefined;
		}
	}

	/*
		---------------------- FORM VALIDATION -------------------------------
	*/

	// Checks validity of all input fields
	private canSavePaymentMethod() : boolean {
		if (
			this.isInvalidFormInput(this.paymentInfo.fName) || 
			this.isInvalidFormInput(this.paymentInfo.lName) || 
			this.isInvalidFormInput(this.paymentInfo.cardNumber) || 
			this.isInvalidFormInput(this.paymentInfo.cvv) || 
			this.isInvalidFormInput(this.paymentInfo.zip) ||
			!this.isValidExpMonth() ||
			!this.isValidExpYear()
			// || !this.agree
		) {
			return false;
		}

		if (this.paymentInfo.cardNumber.length < this.CARD_NUMBER_MIN_LENGTH)
			return false;
		
		return true;
	}

	isInvalidFormInput(propertyValue: any, touched?: boolean): boolean {
		if (!touched && !this.doneClicked)
			return false; 
		if (!!propertyValue)
			return false

		return true;
	}

	isValidExpYear(): boolean {
        let expirationInfo: any = this.getExpirationInfo();

        return expirationInfo ? this.yearNums.includes(expirationInfo.expYear): false;
    }

    isValidExpMonth(): boolean {
        let expirationInfo: any = this.getExpirationInfo();

        return expirationInfo ? this.monthNums.includes(expirationInfo.expMonth): false;
	}

	/*
		-----------------------------------------------------
	*/
	
	openContractTerms() {
		this.modalSvc.show(ContractTermsFreeTrialModalComponent, {});
	}
}
